import Vue from 'vue'
import Router from 'vue-router'

// router modules
import root from './modules/root'
import management from './modules/management'
import core from './modules/core'
import comceptum from './modules/comceptum'
import carpetline from './modules/carpetline'
import fm from './modules/fm'
import fmwebapp from './modules/fmwebapp'
import fmmodule from './modules/fmmodule'

import guards from './guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...root,
    ...management,
    ...core,
    ...comceptum,
    ...carpetline,
    ...fm,
    ...fmwebapp,
    ...fmmodule
  ],
  linkActiveClass: "active"
})

// register all guards
guards.forEach(guard => {
  router.beforeEach((to, from, next) => {
      guard(to, from, next)
  })
})

export default router
